var _defs, _g, _g2, _g3, _g4, _g5, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRainDrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    zoomAndPan: "magnify",
    viewBox: "0 0 750 675.000002",
    height: 900,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "f56ffcc1f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.554688 0 L 749.445312 0 L 749.445312 674 L 0.554688 674 Z M 0.554688 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1696bac1c3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.554688 0 L 749.445312 0 L 749.445312 674 L 0.554688 674 Z M 0.554688 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c598ba6e67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 117.570312 0 L 632.429688 0 C 697.054688 0 749.445312 52.390625 749.445312 117.015625 L 749.445312 556.988281 C 749.445312 621.613281 697.054688 674 632.429688 674 L 117.570312 674 C 52.945312 674 0.554688 621.613281 0.554688 556.988281 L 0.554688 117.015625 C 0.554688 52.390625 52.945312 0 117.570312 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "05818b06e3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 113.386719 25.117188 L 636.859375 25.117188 L 636.859375 286.480469 L 113.386719 286.480469 Z M 113.386719 25.117188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4b5519c950"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 115 272.089844 L 635 272.089844 L 635 306.539062 L 115 306.539062 Z M 115 272.089844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "49eb951657"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 375 306.75 L 561.472656 306.75 L 561.472656 576.351562 L 375 576.351562 Z M 375 306.75 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f56ffcc1f0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.554688 0 L 749.445312 0 L 749.445312 681.492188 L 0.554688 681.492188 Z M 0.554688 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.554688 0 L 749.445312 0 L 749.445312 674 L 0.554688 674 Z M 0.554688 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.554688 0 L 749.445312 0 L 749.445312 674 L 0.554688 674 Z M 0.554688 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1696bac1c3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c598ba6e67)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5c9ce5",
    d: "M 0.554688 0 L 749.445312 0 L 749.445312 674 L 0.554688 674 Z M 0.554688 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#05818b06e3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 636.851562 286.476562 L 608.710938 286.476562 C 608.710938 157.855469 503.921875 53.214844 375.121094 53.214844 C 246.316406 53.214844 141.527344 157.855469 141.527344 286.476562 L 113.390625 286.476562 C 113.390625 142.363281 230.800781 25.117188 375.121094 25.117188 C 519.4375 25.117188 636.851562 142.363281 636.851562 286.476562 Z M 636.851562 286.476562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4b5519c950)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 617.507812 272.089844 L 132.457031 272.089844 C 122.890625 272.089844 115.136719 279.804688 115.136719 289.316406 C 115.136719 298.828125 122.890625 306.539062 132.457031 306.539062 L 617.507812 306.539062 C 627.074219 306.539062 634.832031 298.828125 634.832031 289.316406 C 634.832031 279.804688 627.074219 272.089844 617.507812 272.089844 Z M 617.507812 272.089844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#49eb951657)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 545.308594 430.75 L 473.964844 310.03125 C 472.769531 308.007812 470.589844 306.765625 468.238281 306.765625 C 465.882812 306.765625 463.703125 308.007812 462.507812 310.03125 L 391.152344 430.769531 C 380.59375 446.25 375.015625 464.363281 375.015625 483.171875 C 375.015625 534.542969 416.835938 576.335938 468.238281 576.335938 C 519.640625 576.335938 561.460938 534.542969 561.460938 483.171875 C 561.460938 464.355469 555.871094 446.226562 545.308594 430.75 Z M 468.238281 563.035156 C 424.171875 563.035156 388.324219 527.210938 388.324219 483.171875 C 388.324219 466.976562 393.144531 451.382812 402.253906 438.105469 C 402.351562 437.96875 402.4375 437.828125 402.523438 437.6875 L 468.238281 326.492188 L 533.949219 437.6875 C 534.019531 437.804688 534.09375 437.921875 534.171875 438.039062 L 534.1875 438.054688 C 534.1875 438.058594 534.191406 438.0625 534.191406 438.066406 C 534.195312 438.070312 534.199219 438.078125 534.203125 438.082031 C 543.328125 451.382812 548.152344 466.976562 548.152344 483.171875 C 548.148438 527.210938 512.300781 563.035156 468.238281 563.035156 Z M 468.238281 563.035156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 458.957031 529.921875 C 438.359375 529.921875 421.601562 513.175781 421.601562 492.589844 C 421.601562 488.917969 418.621094 485.941406 414.945312 485.941406 C 411.269531 485.941406 408.292969 488.917969 408.292969 492.589844 C 408.292969 520.507812 431.019531 543.222656 458.957031 543.222656 C 462.632812 543.222656 465.609375 540.246094 465.609375 536.574219 C 465.609375 532.898438 462.632812 529.921875 458.957031 529.921875 Z M 458.957031 529.921875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainDrop);
export default __webpack_public_path__ + "static/media/rain_drop.dfca96882da236d187bf1e0bd056e41c.svg";
export { ForwardRef as ReactComponent };